import { useState } from "react";
import closeicon from "../../../assets/images/close.svg";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import useMotorForm from "../../../hooks/useMotorFormData";
import BackdropModal from "../../common/modal/backdropModal";
import PromoCode from "./promoCode";
import Summary from "./summary";

export const PROMO_CODE = "PROMO_CODE";

const ViewSummaryPopup = ({ show, setShow, passedFrom }) => {
  const onClose = () => setShow((state) => !state);
  const [formState, setFormState] = useState({});
  const { saveMotorDataInRedux, removeMotorFormData } = useMotorForm(
    PROMO_CODE,
    setFormState
  );

  const applyPromoCode = () => {
    saveMotorDataInRedux(formState);
  };
  const translate = useLanguageTranslate();

  return (
    <div className="summarymodal">
      <BackdropModal
        onClose={onClose}
        show={show}
        hideClosebtn
        contentClassName="!w-auto min-w-[300px] lg:min-w-[624px] max-w-[90vw] max767:!w-full max767:max-w-full"
      >
        <div className="flex justify-between items-center mb-4 -mt-6">
          <h2 className="text-[#1A2024] text-2xl not-italic font-semibold leading-6">
            {translate("Summary", "التسعيرة")}
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full max767:bg-[#E5E9EB]"
          >
            <img src={closeicon} alt="Close" className="w-6 h-6" />
          </button>
        </div>
        <div className="bg-white rounded-lg max-h-[80vh] w-full max767:w-full">
          {/* Hide PromoCode for Travel, Personal Accident, and Home Renewal flows in modal */}
          {passedFrom !== "TravelChangePlan" && passedFrom !== "TravelAddCovers" && passedFrom !== "TravelRenewal" && passedFrom !== "personalAccidentRenewal" && passedFrom !== "homeRenewal" && passedFrom !== "personalCyberRenewal" && (
            <PromoCode
              promoCode={formState?.promoCode}
              setPromoCode={(code) =>
                setFormState((prevState) => ({ ...prevState, promoCode: code }))
              }
              applyPromoCode={applyPromoCode}
              clearPromoCode={() => {
                setFormState({});
                removeMotorFormData();
              }}
            />
          )}
          <Summary passedFrom={passedFrom} />
        </div>
      </BackdropModal>
    </div>
  );
};

export default ViewSummaryPopup;
